<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const sidebarMinimize = () => store.commit("sidebarMinimize");

const emit = defineEmits(["close-mobile-sidebar"]);

const minimizeSidebar = () => {
  if (window.innerWidth < 1200) {
    sidebarMinimize();
    emit("close-mobile-sidebar");
  }
};

defineProps({
  to: {
    type: String,
    required: true,
  },
  navText: {
    type: String,
    required: true,
  },
});
</script>
<template>
  <router-link :to="to" class="nav-link" @click="minimizeSidebar">
    <div
      class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
    >
      <slot name="icon"></slot>
    </div>
    <span class="nav-link-text" :class="isRTL ? 'me-1' : 'ms-1'">{{ navText }}</span>
  </router-link>
</template>
